import { Router } from "@vaadin/router";
import { filterPaths } from "./routes";
import { defer, from } from "rxjs";

/* router settings */
let globalroutes = [
  {
    path: "/auth(.*)",
    action: (ctx, commands) => {
      window.location = "/auth.html";
    },
  },
  {
    path: "/",
    action: async (context, commands) => {
      checkAuth();
      await import("./pages/home-page/home-page.js")
        .then(() => console.log("/home-page is loaded"))
        .catch((error) => {
          console.log("error in import home-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
    component: "home-page",
  },
  {
    path: "/invite",
    action: async (context, commands) => {
      if (authStore.userId.value) {
        return commands.redirect("/");
      }
      let code = "";
      if (context.search.includes("code")) {
        code = context.search.split("code=")[1];
      }

      return await import("./pages/invite-user-page/invite-user-page.js")
        .then((module) => {
          console.log("/invite-user-page is loaded");
          return new module.InviteUserPage(code);
        })
        .catch((error) => {
          console.log("error in import invite-user-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/wait-list",
    action: async (context, commands) => {
      // will be used from auth as a step?
      return await import("./pages/wait-list-page/wait-list-page.js")
        .then((module) => {
          console.log("/wait-list is loaded");
          return new module.WaitListPage();
        })
        .catch((error) => {
          console.log("error in import wait-list: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/user/:id",
    action: async (context, commands) => {
      checkAuth();
      let type = "";
      let matchId = "";
      if (context.search) {
        type = context.search.split("?")[1];

        matchId = type.includes("=") ? type.split("=")[1] : "";
        type = type.includes("=") ? type.split("=")[0] : type;
      }

      return await import("./pages/user-page/user-page.js")
        .then((module) => {
          console.log("/user-page is loaded");
          return new module.UserPage(context.params.id, type, matchId);
        })
        .catch((error) => {
          console.log("error in import user-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/edit-preferences",
    action: async (context, commands) => {
      checkAuth();
      return await import(
        "./pages/edit-user-preferences/edit-user-preferences.js"
      )
        .then((module) => {
          console.log("/edit-user-preferences is loaded");
          return new module.EditUserPreferences();
        })
        .catch((error) => {
          console.log("error in import edit-user-preferences: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/edit-user",
    action: async (context, commands) => {
      checkAuth();
      return await import("./pages/edit-user-page/edit-user-page.js")
        .then((module) => {
          console.log("/edit-user-page is loaded");
          return new module.EditUserPage();
        })
        .catch((error) => {
          console.log("error in import edit-user-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/settings",
    action: async (context, commands) => {
      //checkAuth();
      return await import("./pages/settings-page/settings-page.js")
        .then((module) => {
          console.log("/settings-page is loaded");
          return new module.SettingsPage();
        })
        .catch((error) => {
          console.log("error in import settings-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/connections",
    action: async (context, commands) => {
      checkAuth();
      return await import("./pages/connections/connections-page.js")
        .then((module) => {
          console.log("/connections-page is loaded");
          return new module.ConnectionsPage();
        })
        .catch((error) => {
          console.log("error in import connections-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/events",
    action: async (context, commands) => {
      checkAuth();
      return await import("./pages/events/events-page.js")
        .then((module) => {
          console.log("/events-page is loaded");
          return new module.EventsPage();
        })
        .catch((error) => {
          console.log("error in import events-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/invite-links",
    action: async (context, commands) => {
      checkAuth();
      return await import("./pages/invite-links-page/invite-links-page.js")
        .then((module) => {
          console.log("/invite-links-page is loaded");
          return new module.InviteLinksPage();
        })
        .catch((error) => {
          console.log("error in import invite-links-page: ", error);
          if (error && error?.message.includes("failed")) {
            // window.location.reload(true);
          }
        });
    },
  },
  {
    path: "/logout",
    action: async (context, commands) => {
      checkAuth();
      await import("./pages/logout.js");
    },
    component: "logout-page",
  },
  {
    path: "(.*)",
    action: async (context, commands) => {
      // if it is some wrong page
      return commands.redirect("/");
    },
  },
];

export const appRouter = new Router(document.querySelector("#app"), {
  baseUrl: "/",
});

appRouter.setRoutes(filterPaths(globalroutes));

function checkAuth() {
  if (authStore.userId.value) return;

  //store the path and after login -> redirect to that path
  console.log(
    "No userId: redirect to auth, selected path: ",
    window.location.pathname
  );
  localStorage.setItem("page-after-login", window.location.pathname);
  window.location = "/auth.html";
}

/* imports */
import "./main.css";
import "@shoelace-style/shoelace/dist/themes/light.css";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
import { isMobile } from "./utilities/helpers/isMobile.js";
import { authStore } from "./utilities/stores/authStore.js";
setBasePath("../../dist");
import { getMe } from "./utilities/requests/user/get-me.js";

/* check for user in authStore */
if (authStore.userId.value) {
  userCheckWithServer();
}
export async function userCheckWithServer() {
  let response;
  try {
    response = await getMe();
    console.log("Response in userCheckWithServer(getMe), ", response);
    if (response?.user) {
      authStore.userObject.value = response.user;

      let timeout = setTimeout(() => {
        let listener = document.querySelector("common-pages-listeners");
        if (listener) listener.checkForUserData();
        clearTimeout(timeout);
      }, 1000);
    }
  } catch (e) {
    console.log("Error in userCheckWithServer(getMe), ", e);
  }
}

/* shoelace commom components */
import(
  /* webpackPrefetch: true */ "@shoelace-style/shoelace/dist/components/button/button.js"
);
import(
  /* webpackPrefetch: true */ "@shoelace-style/shoelace/dist/components/drawer/drawer.js"
);
import(
  /* webpackPrefetch: true */ "@shoelace-style/shoelace/dist/components/select/select.js"
);
import(
  /* webpackPrefetch: true */ "@shoelace-style/shoelace/dist/components/option/option.js"
);

let headerImport, menuBottomImport, commonPagesListener;

headerImport = defer(() =>
  from(
    import(/* webpackPreload: true */ "./components/organisms/header-section")
  )
);
headerImport.subscribe();

commonPagesListener = defer(() =>
  from(
    import(
      /* webpackPreload: true */ "./components/organisms/common-pages-listeners"
    )
  )
);
commonPagesListener.subscribe();

menuBottomImport = defer(() =>
  from(import(/* webpackPreload: true */ "./components/organisms/menu-bottom"))
);
menuBottomImport.subscribe();

/* 
  Set a class on the body element based on the current page.
  This allows us to apply page-specific styles.
*/
window.addEventListener("vaadin-router-location-changed", (e) => {
  const { pathname } = e.detail.location;
  const currentPage = pathname.split("/")[1] || "home";
  const className = `page-${currentPage}`;

  document.body.classList.forEach((item) => {
    if (item.startsWith("page-")) document.body.classList.remove(item);
  });

  document.body.classList.add(className);
});
